module.exports = {
  "taskSettingsChanged": {
    "name": "Setting Interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "followUpReminderToggled",
        "defaultDueDatePresetChanged",
        "defaultDueTimeChanged",
        "defaultReminderPresetChanged",
        "leadFollowUpReminderToggled"
      ],
      "value": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "tasks"
  },
  "sulSettingsSave": {
    "name": "settings-save",
    "class": "interaction",
    "properties": {
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "settingsui"
  },
  "sulSettingsCancel": {
    "name": "settings-cancel",
    "class": "interaction",
    "properties": {
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "settingsui"
  },
  "sulSettingsEdit": {
    "name": "settings-edit",
    "class": "interaction",
    "properties": {
      "settingId": "string",
      "interaction": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "backLocation": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "settingsui"
  },
  "settingsNavPageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen2": {
        "type": "string",
        "isOptional": true
      },
      "settingsApp": {
        "type": "string",
        "isOptional": true
      },
      "optedIn": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "settingsui"
  },
  "settingsNavInteraction": {
    "name": "settings-navigation",
    "class": "interaction",
    "properties": {
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "settingsGroup": "string",
      "settingsLink": "string",
      "settingsApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "settingsui"
  },
  "settingsNavBackLink": {
    "name": "settings-navigation-back-link",
    "class": "interaction",
    "properties": {
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "settingsApp": {
        "type": "string",
        "isOptional": true
      },
      "backLocation": "string"
    },
    "namespace": "settingsui"
  }
};